import { Col, Row } from "antd";
import Modal from "../modal/Modal";
import TextComponent from "../textComponent/TextComponent";
import SubmitButton from "../submitButton/SubmitButton";
import styles from "./CopyLinkModal.module.css";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { showAlert } from "../../Store/Actions/GeneralActions";

const CopyLinkModal = ({ isCopyModalOpen, setIsCopyModalOpen, link }) => {
  const [isCopied, setIsCopied] = useState(false);
const dispatch = useDispatch();
  // This is the function we wrote earlier
  async function copyTextToClipboard(text) {
    if ("clipboard" in navigator) {
      return await navigator.clipboard.writeText(text);
    }
  }

  // onClick handler function for the copy button
  const handleCopyClick = () => {
    // Asynchronously call copyTextToClipboard
    copyTextToClipboard(link)
      .then(() => {
        dispatch(showAlert({
          type: "Success",
          message: "Copied"
        }))
        // If successful, update the isCopied state value
        setIsCopied(true);
        setIsCopyModalOpen(false)
        setTimeout(() => {
          setIsCopied(false);
        }, 1500);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  return (
    <Modal
      isModalOpen={isCopyModalOpen}
      setIsModalOpen={setIsCopyModalOpen}
      closable={true}
      // pinkBg={true}
      wideModal={true}
      className={styles.modalContent}
    >
      <Row>
        <Col xs={24}>
          <Row>
            <TextComponent textClass={styles.modalTitle}>
              Copy Link
            </TextComponent>
          </Row>
          <Row>
            {/* <Col xs={24}> */}
            <div className={styles.input}>
              <input className={styles.inner_input} placeholder={link} />
            </div>
            <SubmitButton
              title={isCopied ? "Copied" : "Copy Link"}
              btnClass={styles.copyBtn}
              onClick={handleCopyClick}
            />
            {/* </Col> */}
          </Row>
        </Col>
      </Row>
    </Modal>
  );
};

export default CopyLinkModal;
